let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f8JZE")).then(() => parcelRequire('537Fw'));